<template>
	<div :class="['onesteptoStation', { is_Phone: isPhone }]">
		<div @click="leaveStation" class="step_station">

			<div class="con_st" v-show="param.manage==1">
				<label><em>分类名称：</em>
				<input name="text" class="txt" v-model="categoryValue" /></label>
				<em>模块名称：</em>

				<input name="text" class="txt" v-model="descn" /></label>

				<input @click="addCategory" :value="categoryId?'修改':'新增'" type="button" class="add_et" />
			</div>
			<div class="step_station_category">
				<dl class="g-cf">
					<!--dt class="g-fl more">更多行业</dt-->
					<dd class="g-fl">
						<ul class="g-fl">
							<li :class="[{ cur: item.cur }]" v-for="(item, index) in industry" :key="index">
								<span v-if="param.manage==1" @click="delItemFun(item)" class="icon_del">X</span>
								<div @click="drtFun(item)">{{ item.name }}</div>
							</li>
						</ul>
					</dd>
				</dl>
			</div>

			<div class="step_station_com">
				<ul v-show="station.length" class="g-cf">
					<li v-for="(item, index) in station" :key="index">
						<img :src="item.img_url" />
						<div class="dt_con">{{ item.name }}</div>
						<div class="bot_com" v-show="param.manage!=1">
							<span @click="addCollectFun(item)" class="user">收藏</span>
							<span @click="userViewFun($event, item)" class="prev">使用</span>
						</div>
						<div class="bot_com" v-show="param.manage==1">
							<span @click="delViewFun(item)" class="user">删除</span>
							<span @click="eDitviewFun($event, item)" class="prev">编辑</span>
						</div>
					</li>
				</ul>
				<div v-show="!station.length" class="no_data">
					<div><img src="/static/image/empty_icon.png" /></div>
					暂未找到可用的效果！
				</div>
				<div class="block">
					<el-pagination style="margin-top:15px;float:right" @current-change="handleCurrentChange" :page-size="pageSize" :current-page="pageNum" :prev-click="prevClick" :next-click="nextClick" layout=" total, prev, pager, next, jumper" :total="total"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	//import Vue from 'vue'
	import dat from '../../static/js/sideData.js';
	import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
	import api from '@/api/$ajax.js';
	import bus from '@/common/bus.js';
	//var exec = new Vue();
	export default {
		name: 'oneSteptoStation',
		components: {},
		data() {
			return {
				param: {
					id: this.$route.params.id,
					param: this.$route.params.param,
					company_id: this.$route.query.company_id,
					token: this.$route.query.token,
					manage: this.$route.query.manage,
					type: this.$route.query.type,
					lang: this.$route.query.lang,
					domain_url: this.$route.query.domain_url,
					wxp_version_id: '',
					pc_version_id: this.$route.query.pc_version_id,
					mobile_version_id: this.$route.query.mobile_version_id
				},
				preview: '/t1/' + this.$route.params.id + '/',
				preview1: '/t2/' + this.$route.params.id + '/',
				industry: [],
				isSnpyData: false,
				isPhone: this.$route.name !== 't1',
				snpyData: '',
				root: '',
				isTop: false,
				templateId: 0,
				categoryId: "",
				categoryValue: '',
				pageNum: 1,
				total: 0,
				pageSize: 15,
				descn: '',
				station: [{
						image: '/static/image/st.png'
					},
					{
						image: '/static/image/st.png'
					}
				]
			};
		},
		created() {
			//console.log(this.mItem);
			this.getData();
		},
		props: [''],
		computed: {
			...mapGetters([])
		},
		mounted: function() {},
		methods: {
			handleSizeChange(val) { 
				var ts = this;
				ts.pageSize = val;
				ts.pageNum = 1;
				ts.getData();
			},
			handleCurrentChange(val) {
				var ts = this;
				ts.pageNum = val;
				ts.getData();
			},
			prevClick(val) {
				console.log(val);
			},
			nextClick(val) {
				console.log(val);
			},
			drtFun(item) { // 
				var ts = this;
				for(var i = 0; ts.industry.length > i; i++) {
					ts.industry[i].cur = false;
				}
				ts.descn = item.descn;
				ts.categoryId = item.id;
				ts.pageNum=1;
				ts.categoryValue = item.name;
				api.get('/api/effect/list?', false, {
					token: ts.param.token,
					type: ts.param.type,
					category_id: item.id,
					page_num: ts.pageNum,
					page_size: ts.pageSize
				}, function(r) {
					if(r.code == 422) {
						return;
					}

					item.cur = true;
					if(r.data && r.data.list) {
						ts.station = r.data.list;
						ts.total = r.data.totalRow;
					}
				});
			},
			addCollectFun(item) { //收藏功能
				let ts = this;
				//console.log("addCollectFun");
				api.get('/api/effect/get?id=' + item.id, false, {}, function(r) {
					if(r.code == 422) {
						return;
					}

					$('#loadGit').hide();
					let categorg = {};
					for(let i = 0; ts.industry.length > i; i++) {
						if(ts.industry[i].id == item.category_id) {
							categorg = ts.industry[i];
						}
						//debugger;
					}

					bus.$emit('onAddCollect', categorg, r.data.item);
					ts.$emit('materialFun', false);
				});
			},

			leaveStation(e) { //
				this.$emit('leaveStation');
			},
			userViewFun(event, item) { //使用
				event.stopPropagation();
				let ts = this;
				$('#loadGit').show();
				api.get('/api/effect/get?id=' + item.id, false, {}, function(r) {
					if(r.code == 422) {
						return;
					}
					$('#loadGit').hide();
					bus.$emit('onMaterial', item.id, r.data.item.config);
					ts.$emit('materialFun', false);
				});
			},
			delItemFun(item) { // 删除分类
				let ts = this;
				// debugger
				//删除分类：api/effect/delCategory?id=3
				api.get('/api/effect/delCategory?token=' + ts.param.token + '&type=' + ts.param.type + '&id=' + item.id, false, {}, function(r) {
					if(r.code == 422) {
						return;
					}

					ts.getCategoryList();
				});
			},
			delViewFun(item) { // 删除模板
				var ts = this;
				$('#loadGit').show();
				api.get('/api/effect/del?token=' + ts.param.token + '&type=' + ts.param.type + '&id=' + item.id, true, {}, function(r) {
					if(r.code == 422) {
						return;
					}
					$('#loadGit').hide();
					api.get('/api/effect/list?', false, {
						token: ts.param.token,
						type: ts.param.type,
						category_id: ts.categoryId,
						page_num: 1,
						page_size: 15
					}, function(r) {
						if(r.code == 422) {
							return;
						}

						if(r.data && r.data.list) {
							ts.station = r.data.list;
							ts.total = r.data.totalRow;
						}
					});
				});
			},
			addCategory(e) { // 新增分类
				let ts = this;
				// name=111 & is_show = 1 & show_no = 11 & descn = 232232 & id=3
				if(ts.categoryValue) {
					api.get(
						'/api/effect/saveCategory?name=' +
						ts.categoryValue +
						'&type=' +
						ts.param.type +
						'&token=' +
						ts.param.token +
						'&id=' +
						ts.categoryId +
						'&is_show=1&show_no=1&descn=' +
						ts.descn,
						true, {},
						r => {
							if(r.code == 422) {
								return;
							}
							//ts.category = '';
							ts.categoryValue = '';
							ts.descn = '';
							ts.getCategoryList();
							if(ts.categoryId) {
								alert('修改类型成功!');
								return;
							}
							alert('添加类型成功!');
						}
					);
				}
			},
			eDitviewFun(event, item) { //
				event.stopPropagation();
				let ts = this;
				api.get('/api/effect/get?token=' + ts.param.token + '&id=' + item.id, false, {}, function(r) {
					if(r.code == 422) {
						return;
					}
					bus.$emit('onMaterial', item.id, r.data.item.config);
					ts.$emit('materialFun', false);
				});
			},
			getCategoryList() { //
				let ts = this;
				api.get('/api/effect/categoryList?token=' + ts.param.token + '&type=' + ts.param.type, false, {}, function(r) {
					if(r.code == 422) {
						return;
					}

					for(var i = 0; r.data.list.length > i; i++) {
						r.data.list[i].cur = false;
					}

					if(r.data.list && r.data.list.length) {
						ts.list = r.data.list;
						ts.list.unshift({
							code: '',
							cur: true,
							name: '全部',
							show_no: 3,
							type: 1,
							is_show: 1
						});
						ts.industry = ts.list;
					}
				});
			},
			getData() { //
				var ts = this;
				api.get('/api/effect/categoryList', false, {}, function(r) {
					if(r.code == 422) {
						return;
					}

					for(var i = 0; r.data.list.length > i; i++) {
						r.data.list[i].cur = false;
					}

					if(r.data.list && r.data.list.length) {
						ts.industry = r.data.list;
						ts.industry.unshift({
							code: '',
							cur: true,
							name: '全部',
							show_no: 3,
							type: 1,
							is_show: 1
						});
					}
				});
				$('#loadGit').show();
				api.get('/api/effect/list?page_size=' + ts.pageSize + '&page_num=' + ts.pageNum, false, {}, function(r) {
					if(r.code == 422) {
						return;
					}
					$('#loadGit').hide();
					if(r.data && r.data.list) {
						ts.station = r.data.list;
						ts.total = r.data.totalRow;
					}
				});
			},
			...mapMutations(['setCurOrder'])
		}
	};
</script>

<style lang="scss" scoped>
	.con_st {
		.txt {
			height: 30px;
			line-height: 30px;
			border: 1px solid #ececec;
		}
		.add_et {
			height: 30px;
			width: 60px;
			margin-left: 10px;
			line-height: 30px;
			color: #444;
			cursor: pointer;
			border: 1px solid #ececec;
		}
	}
	
	.onesteptoStation {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 80px;
		-webkit-transition: all 0.4s ease 0.2s;
		transform: translateY(-100%);
		overflow: auto;
		left: 0;
		background-color: #fff;
		box-sizing: border-box;
		box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15);
		padding: 30px 0 150px;
		z-index: 99999;
	}
	
	.step_station_category {
		margin-top: 10px;
		li {
			position: relative;
			.icon_del {
				display: none;
				position: absolute;
				top: -10px;
				right: 0;
				color: red;
			}
		}
		li:hover .icon_del {
			display: block;
		}
		li:first-child .icon_del {
			display: none;
		}
	}
	
	.stat {
		transform: translateY(0);
	}
	
	.step_station_category {
		line-height: 30px;
		margin-bottom: 10px;
		ul {
			li {
				float: left;
				text-align: center;
				padding: 0 30px;
				cursor: pointer;
			}
			li.cur {
				background-color: #0e83ee;
				color: #fff;
				border-radius: 15px;
			}
		}
		.more {
			cursor: pointer;
			width: 100px;
			font-size: 14px;
			height: 32px;
			line-height: 32px;
			margin-right: 30px;
			text-align: center;
			border: 1px solid #e3e2e8;
			border-radius: 2px;
			cursor: pointer;
		}
	}
	
	.no_data {
		text-align: center;
		margin-top: 50px;
		color: #999;
	}
	
	.step_station {
		width: 1200px;
		margin: 0 auto;
	}
	
	.onesteptoStation {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 80px;
		-webkit-transition: all 0.4s ease 0.2s;
		transform: translateY(-100%);
		overflow: auto;
		left: 0;
		background-color: #fff;
		box-sizing: border-box;
		box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15);
		padding: 30px 0 150px;
		z-index: 99999;
	}
	
	.stat {
		transform: translateY(0);
	}
	
	.step_station_category {
		line-height: 30px;
		margin-bottom: 10px;
		ul {
			li {
				float: left;
				text-align: center;
				padding: 0 30px;
				cursor: pointer;
			}
			li.cur {
				background-color: #0e83ee;
				color: #fff;
				border-radius: 15px;
			}
		}
		.more {
			cursor: pointer;
			width: 100px;
			font-size: 14px;
			height: 32px;
			line-height: 32px;
			margin-right: 30px;
			text-align: center;
			border: 1px solid #e3e2e8;
			border-radius: 2px;
			cursor: pointer;
		}
	}
	
	.step_station_com {
		li {
			float: left;
			width: 380px;
			position: relative;
			padding: 10px;
			overflow: hidden;
			.bot_com {
				position: absolute;
				left: 0;
				top: 0;
				text-align: center;
				-webkit-transition: all 0.4s ease 0.2s;
				transform: translateY(100%);
				background-color: rgba(0, 0, 0, 0.5);
				width: 100%;
				height: 100%;
				span {
					display: inline-block;
					background-color: #fff;
					border-radius: 15px;
					height: 30px;
					margin-top: 30%;
					margin-right: 20px;
					cursor: pointer;
					line-height: 30px;
					width: 80px;
					text-align: center;
				}
				span:hover {
					background-color: #0e83ee;
					color: #fff;
				}
			}
			img {
				width: 380px;
				height: 250px;
			}
		}
		li:hover {
			.bot_com {
				transform: translateY(0);
			}
		}
	}
	
	.is_Phone {
		.step_station_com {
			li {
				width: 250px;
				height: 200px;
				/*background: url(/static/image/mbg_use_01.png) no-repeat 0 0;*/
				.bot_com {
					transform: translateY(100%);
					width: 250px;
					height: 200px;
				}
				img {
					width: 100%;
					height: 100%;
				}
			}
			li:hover {
				.bot_com {
					transform: translateY(0);
				}
			}
		}
	}
	
	.no_data {
		text-align: center;
		margin-top: 50px;
		color: #999;
	}
	
	.step_station {
		width: 1200px;
		margin: 0 auto;
	}
	
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
		background-color: #f1f1f1;
	}
	
	::-webkit-scrollbar-thumb {
		background-color: #b2b2b2;
		width: 16px;
		-webkit-border-radius: 16px;
		-moz-border-radius: 16px;
		border-radius: 16px;
	}
</style>


// WEBPACK FOOTER //
// src/components/oneMaterial.vue